import { Zap, Award, Headphones, Tag } from "lucide-react";

const features = [
  {
    icon: Zap,
    title: "Transaksi Cepat",
    description: "Proses pembelian yang cepat dan aman melalui WhatsApp dengan sistem pembayaran yang transparan dan terjamin keamanannya.",
    color: "text-warning",
    bgColor: "bg-warning/10",
  },
  {
    icon: Award,
    title: "Akun Premium",
    description: "Setiap akun premium telah melalui verifikasi manual tim kami, dengan fitur lengkap dan status aktif yang siap digunakan.",
    color: "text-primary",
    bgColor: "bg-primary/10",
  },
  {
    icon: Headphones,
    title: "Admin Support",
    description: "Tim support kami siap membantu Anda kapan saja dengan respon cepat dan solusi terbaik untuk setiap kebutuhan.",
    color: "text-info",
    bgColor: "bg-info/10",
  },
  {
    icon: Tag,
    title: "Harga Murah",
    description: "Harga yang terjangkau mulai dari Rp5.000 dengan transparansi penuh, tanpa biaya tersembunyi atau komisi tambahan.",
    color: "text-success",
    bgColor: "bg-success/10",
  },
];

export function FeaturesSection() {
  return (
    <section className="py-16 lg:py-24 bg-card">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Mengapa Memilih <span className="text-gradient">Kami?</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Kami berkomitmen memberikan pengalaman jual beli akun premium yang aman, nyaman, dan terpercaya untuk semua kebutuhan Anda.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="group p-6 bg-background rounded-2xl border border-border hover:shadow-card transition-all duration-300 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className={`w-14 h-14 rounded-2xl ${feature.bgColor} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <feature.icon className={`h-7 w-7 ${feature.color}`} />
              </div>
              <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
              <p className="text-sm text-muted-foreground">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
